<template>
  <div class="center">
    <img src="../assets/icon/error.png" class="err-icon" alt="">
    <div class="err-title">支付失败!</div>
    <div class="err-detail">{{ msg }}</div>

    <div class="know-bt">
      <van-button color="linear-gradient(to right, #ff6034, #ee0a24)" @click="iKnow">
        我知道了
      </van-button>
    </div>

  </div>
</template>

<script>
import wayCode from "@/utils/wayCode"
import {Button} from 'vant';
// 分发器页面，  用户扫码后进入的第一个页面：
// 判断是否存在channelUserId, 如果存在则直接跳到 对应的支付页面，如果不存在则重定向到对应的页面。
export default {
  data() {
    return {
      payType: wayCode.getPayWay().channel,
      msg: "请重新扫码进入！",
    }
  },
  components: {
    [Button.name]: Button,
  },
  mounted() {
    this.msg = this.$route.params.errInfo || '请重新扫码进入！';
    document.title = '支付结果';
  },
  methods: {
    iKnow() {
      if (this.payType === 'wx') {
        window.WeixinJSBridge.call('closeWindow')
      } else if (this.payType === 'ali') {
        window.AlipayJSBridge.call('closeWebview')
      } else {
        alert("请关闭页面，重新扫码");
      }
    }
  }
}
</script>
<style lang="css" scoped>
.center {
  /*background-color: #f4f4f5;*/
  margin-top: 30%;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.err-icon {
  width: 2rem;
}
.err-title {
  color: #303133;
  font-size: 0.36rem;
  margin-top: 0.2rem;
}

.err-detail {
  color: #909399;
  font-size: 0.32rem;
  margin-top: 0.26rem;
}

.know-bt {
  margin-top: 4rem;
}

/deep/ .van-button {
  width: 3rem;
  border-radius: 0.5rem;
}
</style>
